import { render, staticRenderFns } from "./NTOPendingUsers.vue?vue&type=template&id=d966aef6&scoped=true&"
import script from "./NTOPendingUsers.vue?vue&type=script&lang=js&"
export * from "./NTOPendingUsers.vue?vue&type=script&lang=js&"
import style0 from "./NTOPendingUsers.vue?vue&type=style&index=0&id=d966aef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d966aef6",
  null
  
)

export default component.exports